import type { Components, Theme } from '@mui/material'
import { RadioChecked } from 'assets/icons/radio-checked'
import { RadioUnchecked } from 'assets/icons/radio-unchecked'

type MuiRadioSettings = Components<Omit<Theme, 'components'>>['MuiRadio']

export const MuiRadio: MuiRadioSettings = {
  defaultProps: {
    checkedIcon: <RadioChecked />,
    icon: <RadioUnchecked />,
  },
}
